import { render, staticRenderFns } from "./AppMe.vue?vue&type=template&id=527fcfb0&"
import script from "./AppMe.vue?vue&type=script&lang=js&"
export * from "./AppMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports